<template>
  <div>
    <span class="title">{{ data.SonFiyat }}</span> &nbsp;
    <span
      class="subtitle"
      v-bind:class="{'has-text-danger': (data.Fark < 0), 'has-text-success' : (data.Fark > 0)}"
    >{{ data.Fark }} (%{{ data.FarkYuzde }})</span>
    <p class="info">{{ $t('app.last_update') }}: {{ data.Tarih }}</p>
    <div class="columns is-tablet">
      <div class="column">
        <table class="table is-fullwidth">
          <tr>
            <td>{{ $t('app.latest_price') }}</td>
            <th>{{ data.SonFiyat }}</th>
          </tr>
          <tr>
            <td>{{ $t('app.opening') }}</td>
            <th>{{ data.Acilis }}</th>
          </tr>
          <tr>
            <td>{{ $t('app.high') }}</td>
            <th>{{ data.Yuksek }}</th>
          </tr>
          <tr>
            <td>{{ $t('app.low') }}</td>
            <th>{{ data.Dusuk }}</th>
          </tr>
          <tr>
            <td>{{ $t('app.volume') }}</td>
            <th>{{ data.Hacim }}</th>
          </tr>
          <tr>
            <td>{{ $t('app.average') }}</td>
            <th>{{ data.Ortalama }}</th>
          </tr>
          <tr>
            <td>{{ $t('app.annual_change') }}</td>
            <th>%{{ data.OncYil }}</th>
          </tr>
        </table>
      </div>
      <div class="column">
        <table class="table is-fullwidth">
          <tr>
            <td>{{ $t('app.market_cap') }}</td>
            <th>{{ data.PiyasaDegeri }}</th>
          </tr>
          <tr>
            <td>{{ $t('app.balance_sheet_period') }}</td>
            <th>{{ data.BilancoDonemi }}</th>
          </tr>
          <tr>
            <td>{{ $t('app.capital') }}</td>
            <th>{{ data.Sermaye }}</th>
          </tr>
          <tr>
            <td>{{ $t('app.equity') }}</td>
            <th>{{ data.OzSermaye }}</th>
          </tr>
          <tr>
            <td>{{ $t('app.book_value') }}</td>
            <th>{{ data.DefterDegeri }}</th>
          </tr>
          <tr>
            <td>PD/DD</td>
            <th>{{ data.PiyDegDefterDeg }}</th>
          </tr>
          <tr>
            <td>FK</td>
            <th>{{ data.FK }}</th>
          </tr>
        </table>
      </div>
    </div>

    <table class="table is-fullwidth is-hidden">
      <tr>
        <th>Sektör</th>
        <td colspan="2">{{ data.Sektor }}</td>
      </tr>
      <tr>
        <th>Son Fiyat</th>
        <th>Fark</th>
        <th>Fark Yüzde(%)</th>
      </tr>
      <tr>
        <td>{{ data.SonFiyat }}</td>
        <td>{{ data.Fark }}</td>
        <td>{{ data.FarkYuzde }}</td>
      </tr>
      <tr>
        <th>OncGun</th>
        <th>OncHafta</th>
        <th>Onc1Hafta</th>
      </tr>
      <tr>
        <td>{{ data.OncGun }}</td>
        <td>{{ data.OncHafta }}</td>
        <td>{{ data.Onc1Hafta }}</td>
      </tr>
      <tr>
        <th>OncAy</th>
        <th>Onc1Ay</th>
        <th>Onc3Ay</th>
      </tr>
      <tr>
        <td>{{ data.OncAy }}</td>
        <td>{{ data.Onc1Ay }}</td>
        <td>{{ data.Onc3Ay }}</td>
      </tr>
      <tr>
        <th>Onc6Ay</th>
        <th>OncYil</th>
        <th>Onc1Yil</th>
      </tr>
      <tr>
        <td>{{ data.Onc6Ay }}</td>
        <td>{{ data.OncYil }}</td>
        <td>{{ data.Onc1Yil }}</td>
      </tr>
      <tr>
        <th>FK</th>
        <th>Halka Açıklık</th>
        <th>PiyDegDefterDeg</th>
      </tr>
      <tr>
        <td>{{ data.FK }}</td>
        <td>{{ data.HalkakAciklik }}</td>
        <td>{{ data.PiyDegDefterDeg }}</td>
      </tr>
      <tr>
        <th>Piyasa Değeri</th>
        <th>Defter Değeri</th>
        <th>Bilanço Dönemi</th>
      </tr>
      <tr>
        <td>{{ data.PiyasaDegeri }}</td>
        <td>{{ data.DefterDegeri }}</td>
        <td>{{ data.BilancoDonemi }}</td>
      </tr>
      <tr>
        <th>Sermaye</th>
        <th>Öz Sermaye</th>
        <th>NetKar</th>
      </tr>
      <tr>
        <td>{{ data.Sermaye }}</td>
        <td>{{ data.OzSermaye }}</td>
        <td>{{ data.NetKar }}</td>
      </tr>
      <tr>
        <th>Senet Sayısı</th>
        <th>Hacim</th>
        <th>Grup</th>
      </tr>
      <tr>
        <td>{{ data.SenetSayisi }}</td>
        <td>{{ data.Hacim }}</td>
        <td>{{ data.Grup }}</td>
      </tr>
      <tr>
        <th>Açılış</th>
        <th>Yüksek</th>
        <th>Düşük</th>
      </tr>
      <tr>
        <td>{{ data.Acilis }}</td>
        <td>{{ data.Yuksek }}</td>
        <td>{{ data.Dusuk }}</td>
      </tr>
      <tr>
        <th>Tanım</th>
        <th>Tarih</th>
        <th>Ortalama</th>
      </tr>
      <tr>
        <td>{{ data.Tanim }}</td>
        <td>{{ data.Tarih }}</td>
        <td>{{ data.Ortalama }}</td>
      </tr>
    </table>
  </div>
</template>

<script>
import axios from "axios";
import iconv from "iconv-lite";
import { mapState, mapMutations } from "vuex";


export default {
  
  computed: {
    ...mapState(["symbol", "tradeName"])
  },
  data: function() {
    return {
      data: []
    };
  },
  mounted: function() {
    axios
      .get(
        process.env.VUE_APP_PROXY +
        "cmd=SirketDetay?symbol=" +
          this.symbol +
          "?lang=" +
          this.$i18n.locale,
        { responseType: "arraybuffer", responseEncoding: "binary" }
      )
      .then(response => this.initJSON(response));
  },
  methods: {
    initJSON: function(response) {
      this.data = JSON.parse(
        iconv.decode(Buffer.from(response.data), "ISO-8859-9")
      );
      this.setTradeName(this.data.Tanim);
      document.title =
        this.tradeName + " - " + this.symbol + " Yatırımcı İlişki Sayfası";
    },
    ...mapMutations(["setTradeName"])
  }

  
};
</script>